/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type CutQueuedOutDeferredReasonCode = typeof CutQueuedOutDeferredReasonCode[keyof typeof CutQueuedOutDeferredReasonCode] | null;


export const CutQueuedOutDeferredReasonCode = {
  live: 'live',
  processing: 'processing',
  legal_hold: 'legal_hold',
  cut_running: 'cut_running',
} as const;
